import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';

Component('tr-kanban-todolist-title', {
  properties: {
    guid: String,
    todolistSelector: String,
  },

  ready() {
    this.syncTodoCount();
  },

  syncTodoCount() {
    if (!this.todolistSelector) return;

    const todolist = closest(this, this.todolistSelector);
    if (!todolist) return;

    const name = this.querySelector('.todolist-title-name');
    name.dataset.todoCount = todolist.todoCount;
  },
});
